import React from 'react'
import Pagetitle from './component/Pagetitle'
import MyAccountNav from './component/MyAccountNav'
import { Link } from 'react-router-dom'
import { useAuth } from './hooks/AuthProvider'

function MyAccount() {
    const {user}=useAuth();
  return (
    <>
    <Pagetitle title="My Account"/>
    <section className="flat-spacing-11">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <MyAccountNav activeLink="dashboard"/>
                    </div>
                    <div className="col-lg-9">
                        <div className="my-account-content account-dashboard">
                            <div className="mb_60">
                                <h5 className="fw-5 mb_20">Hello {user}</h5>
                                <p>
                                    From your account dashboard you can view your <Link className="text_primary" to="/my-account-orders">recent orders</Link>, manage your <Link className="text_primary" to="/my-account-address">shipping and billing addresses</Link>, and <Link className="text_primary" to="/my-account-edit">edit your password and account details</Link>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
    </>
  )
}

export default MyAccount